import React from "react";
import Invoice from "./Invoice";

const InvoiceList = ({ invoices }) => {
  return (
    <div className="flex flex-col gap-3">
      {invoices.map((invoice) => (
        <Invoice key={`invoice-${invoice.sbid}`} {...invoice} />
      ))}
    </div>
  );
};

export default InvoiceList;
